import { render, staticRenderFns } from "./studentEdit-pc.vue?vue&type=template&id=532c65ca&scoped=true&"
import script from "./studentEdit-pc.vue?vue&type=script&lang=js&"
export * from "./studentEdit-pc.vue?vue&type=script&lang=js&"
import style0 from "./studentEdit-pc.vue?vue&type=style&index=0&id=532c65ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c65ca",
  null
  
)

export default component.exports